/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, count: NonNullable<unknown> }} Spaces_Toast_Folder_Deleted_SuccessInputs */



/**
* | output |
* | --- |
* | "Folder \"{name}\" and {count} files deleted successfully" |
*
* @param {Spaces_Toast_Folder_Deleted_SuccessInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_toast_folder_deleted_success = /** @type {((inputs: Spaces_Toast_Folder_Deleted_SuccessInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Toast_Folder_Deleted_SuccessInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Ordner "${i?.name}" und ${i?.count} Dateien erfolgreich gelöscht`)
	return /** @type {LocalizedString} */ (`Folder "${i?.name}" and ${i?.count} files deleted successfully`)
});